import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Button from '../../../../../../../../components/Button'
import RadioBlock from '../../../../../../../../components/Form/RadioBlock'
import MultipleOptionsField from '../../../../../../../ReusableFormFields/MultipleOptionsField'

import { VIDEO_ADS_BLANK, VIDEO_ADS_ENTER, VIDEO_ADS_OPTION, VIDEO_ADS_URL } from '../../../../../fields'

import useStyles from '../../../../../../../../styles/common/stepForms'

const stepFields = [VIDEO_ADS_URL]

function VideoAdsStep({ formik, handleStepChange }) {
  const { t } = useTranslation()
  const commonClasses = useStyles()

  const { values, setFieldValue } = formik

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields, values)
  }, [values, handleStepChange])

  return (
    <>
      <div className={commonClasses.stepTitle}>{t('Provide the URLs for YouTube video ads (if any)')}</div>
      <div className={commonClasses.stepBody}>
        <RadioBlock
          setFieldValue={setFieldValue}
          id="radio_video_ads_enter"
          name={VIDEO_ADS_OPTION}
          value={VIDEO_ADS_ENTER}
          selectedValue={values[VIDEO_ADS_OPTION]}
          label={t('Enter video url')}
        >
          <MultipleOptionsField
            fieldLabel="YouTube Video link"
            listFieldName={VIDEO_ADS_URL}
            formik={formik}
            minListQuantity={1}
            initialValue={'https://www.youtube.com'}
          />
        </RadioBlock>

        <RadioBlock
          setFieldValue={setFieldValue}
          id="radio_video_ads_blank"
          name={VIDEO_ADS_OPTION}
          value={VIDEO_ADS_BLANK}
          selectedValue={values[VIDEO_ADS_OPTION]}
          label={t('I don’t have a YouTube video to add')}
        />
      </div>
      <div className={commonClasses.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

VideoAdsStep.propTypes = {
  handleStepChange: PropTypes.func,
  formik: PropTypes.object
}

export default VideoAdsStep
